
<div class="grid-container full-height full v-pad">
  <div>
    <!-- hide/show -->
    <form class="user-form-max-width" [formGroup]="mergeFieldsForm">
      <h2>Merge Fields (OnBase Keyword Values must be provided here)</h2>
      <div class="cell small-12">
        <label for="applicationNumber">Application #:</label>
      </div>
      <div class="cell small-12 input-group">
        <input class="no-margin" id="applicationNumber" formControlName="applicationNumber" readonly type="text" />
      </div>
      @for (value of reportTemplate.reportContextValues; track value) {
        <div>
          <div class="grid-x grid-margin-x">
            <div class="cell small-12">
              @if (!value.systemProvided) {
                <div class="cell small-12 input-group">
                  <label for="{{value.displayName}}">{{value.displayName}} </label>
                </div>
              }
              @if (value.systemProvided) {
                <div class="cell small-12 input-group">
                  <label for="{{value.displayName}}">{{value.displayName}} - This value will be set by the system.</label>
                </div>
              }
            </div>
            <div class="cell small-12 input-group">
              <input class="no-margin" formControlName="{{value.displayName}}" type="text" />
            </div>
          </div>
        </div>
      }
      <button class="next-link vertical-middle" (click)="onNextClick()">
        <span>Next</span>
        <span aria-hidden="true" class="next-link-span">
          <svg-icon icon="icon-chevron-right" class="white" aria-hidden="true"></svg-icon>
        </span>
      </button>
    </form>

  </div>
</div>

